import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { RiChatFollowUpFill } from "react-icons/ri";
import Swal from "sweetalert2";
import IconButton from "@mui/material/IconButton";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";

function UpdateFollowup(props) {
  const getNextWeekDateStr = () => {
    const d = new Date();
    d.setDate(d.getDate() + 7);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const [followDate, setFollowDate] = useState(getNextWeekDateStr());
  const [remarks, setRemarks] = useState("");
  const [stagearr, setStagearr] = useState([]);
  const [selectedstage, setselectedstage] = useState("");
  const followupformGetdata = async (enquiryID) => {
    let obj = {
      query: `[dbo].[CRM_Proc_FollowupForm_GetData] @agentid='{0}',@enquiryid='{1}'`,
      queryArr: [`${props.AgentID}`, `${enquiryID}`],
    };

    try {
      const resp = await Hexapi(obj);
      console.log(resp);
      const stagearr = resp["stage"];
      setStagearr(stagearr);
    } catch (err) {
      console.error("Error fetching Followup details:", err);
    } finally {
    }
  };
  useEffect(() => {
    if (props.isOpen) {
      followupformGetdata(props.enquiryID);
      // reset form values when modal opens
      setFollowDate(getNextWeekDateStr());
      setselectedstage("");
      setRemarks("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen]);

  const handlefollowup = async () => {
    if (!followDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill Follow Date before submitting.",
      });
      return;
    }

    if (!selectedstage) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please select Stage before submitting.",
      });
      return;
    }

    const obj = {
      query: `[dbo].[CRM_Proc_FollowupForm_Submit] @EnquiryID='{0}', @Followupdate='{1}', @Remarks='{2}', @StageID='{3}'`,
      queryArr: [
        `${props.enquiryID}`,
        `${followDate}`,
        `${remarks}`,
        `${selectedstage}`,
      ],
    };

    try {
      const resp = await Hexapi(obj);
      console.log("Follow-up submit response:", resp);

      const result = resp[""]?.[0];
      const msg = result?.msg || "No response message from server.";
      const cmd = result?.command;

      if (cmd === 1) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: msg,
          timer: 1500,
          showConfirmButton: false,
        });
        setTimeout(() => {
          props.onClose?.();
          props.ReloadActionModal(props.enquiryID);
        }, 500);
      } else if (cmd === 0) {
        Swal.fire({
          icon: "warning",
          title: "Action Failed",
          text: msg,
        });
      }
    } catch (err) {
      console.error("Follow-up Error:", err);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "There was an error submitting the follow-up.",
      });
    }
  };
  return (
    <>
      <RiChatFollowUpFill
        style={{ cursor: "pointer", fontSize: "25px" }}
        title="Update Follow Up"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          props.onOpen?.();
        }}
      />
      <Modal
        show={props.isOpen}
        onHide={() => props.onClose?.()}
        dialogClassName="custom-modall-followup"
        size="lg"
        backdrop="static"
        scrollable
      >
        <Modal.Header closeButton style={{ backgroundColor: "#f5f9ff" }}>
          <div className="w-100">
            {/* Title */}
            <div>
              <strong>Follow up date Update Form</strong>
            </div>

            {/* Second line: EnquiryID + CustomerName */}
            <div className="d-flex gap-4 mt-2">
              <span>
                <strong>EnquiryID:</strong> {props.enquiryID}
              </span>
              <span>
                <strong>CustomerName:</strong> {props.customerName}
              </span>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
          <form className="p-3">
            {/* Follow Date */}
            <div className="mb-3">
              <label className="form-label">FollowDate :</label>
              <input
                type="date"
                className="form-control"
                value={followDate}
                onChange={(e) => setFollowDate(e.target.value)}
                onFocus={(e) => e.target.showPicker && e.target.showPicker()}
              />
            </div>
            <label className="form-label">Stage :</label>
            <select
              className="form-select"
              value={selectedstage}
              onChange={(e) => setselectedstage(e.target.value)}
            >
              <option value="">Select Stage</option>
              {stagearr?.length > 0 ? (
                stagearr.map((item, index) => (
                  <option key={index} value={item.stageid}>
                    {item.stage}
                  </option>
                ))
              ) : (
                <option disabled>No Stage available</option>
              )}
            </select>

            {/* Remarks */}
            <div className="mb-3">
              <label className="form-label">Remarks :</label>
              <input
                type="text"
                className="form-control"
                placeholder="Remarks"
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>

            {/* Submit Button */}
            <div className="text-center">
              <IconButton
                sx={{
                  display: "block",
                  mx: "auto",
                  mt: 3,
                  mb: 3,
                  px: 3,
                  py: 1,
                  borderRadius: "8px",
                  backgroundColor: "#000",
                  border: "1px solid #000",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#fff",
                    color: "#000",
                  },
                  fontSize: "20px",
                  fontWeight: "bold",
                }}
                onClick={() => handlefollowup()}
              >
                Submit
              </IconButton>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default UpdateFollowup;
